/**
 * EM 计划助手，mixin
 *   提供功能如下：
 *     1：执行到期计划
 *     2：执行vuex.rows中选中的计划

 * Author YuJiaBei
 * Date 2020-07-17 09:14:36
 */

import emRouteHelperMixin from "@/mixin/em/helper/route";
import axios from "axios";

export default {
    mixins: [emRouteHelperMixin],
    computed: {
        //默认采用modalName,其次采用路由中的entityName作为planName，如需自定义，请覆盖
        $_emPlanHelperMixin_planName() {
            if (this.modalName) {
                return this.modalName
            } else if (this.$_emRouterHelperMixin_entityName) {
                return this.$_emRouterHelperMixin_entityName
            } else {
                return ""
            }
        }
    },
    methods: {
        $_emPlanHelperMixin_runPlans() {
            //取vuex中rows的当前选中项
            let checkedItems = this.$store.state[this.$_emPlanHelperMixin_planName]["checkedItems"];
            if (checkedItems) {
                let params = 'ids=' + checkedItems.join(',');
                this.$store.dispatch("api/post", {
                    url: `${this.$_emRouterHelperMixin_baseBackendUrl}/${this.$_emPlanHelperMixin_planName}/runPlans?${params}`,
                    data: {}
                })
                    .then(responseBody => {
                        //成功提示
                        this.$store.dispatch("base/showSuccess", {
                            userAlertSuccessStr: `成功【${responseBody.data.runSuccessCount}】，失败【${responseBody.data.runFailureCount}】`,
                            dismissCountDown: 5,
                            userAlertSuccessVisible: false
                        })
                            .then(() => {
                                //todo：刷不出新记录。。。
                                this.$store.dispatch("base/MMFLoadRows", this.$_emPlanHelperMixin_planName);
                            })
                    })
            }


        },
        $_emPlanHelperMixin_runDuePlans() {
            this.$store.dispatch("api/post", {
                url: `${this.$_emRouterHelperMixin_baseBackendUrl}/${this.$_emPlanHelperMixin_planName}/runDuePlans`,
                data: {}
            })
                .then(responseBody => {
                    //成功提示
                    this.$store.dispatch("base/showSuccess", {
                        userAlertSuccessStr: `成功【${responseBody.data.runSuccessCount}】，失败【${responseBody.data.runFailureCount}】`,
                        dismissCountDown: 5,
                        userAlertSuccessVisible: false
                    })
                        .then(() => {
                            //todo：刷不出新记录。。。
                            this.$store.dispatch("base/MMFLoadRows", this.$_emPlanHelperMixin_planName);
                        })
                })

        },
        $_emPlanHelperMixin_runPlanManual() {
            //取vuex中rows的当前选中项
            let checkedItems = this.$store.state[this.$_emPlanHelperMixin_planName]["checkedItems"];
            if (checkedItems) {
                return new Promise((resolve, reject) => {
                    let params = 'ids=' + checkedItems.join(',');
                    this.$store.dispatch("api/post", {
                        url: `${this.$_emRouterHelperMixin_baseBackendUrl}/${this.$_emPlanHelperMixin_planName}/runPlansBySelf?${params}`,
                        data: {}
                    })
                        .then(response => resolve(response))
                        .catch(error => reject(error))
                })
            }
        }
    }
}
